<div class="bg-white custom-hv">
  <div class="container">
    <div class="row justify-content-center mt-4">
      <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
        <img src="assets/images/edu-logo.svg" alt="{{ genericMessage['G0001'] }}" class="img-fluid" />
      </div>
    </div>
    <hr />
    <div class="col-lg-12 col-md-12 col-sm-12 mx-auto pb-5">
      <div class="mt-5">
        <h3 id="registration_heading">Educator Preparation Provider (EPP) Registration</h3>
      </div>
      <div class="mt-4">
        <form [formGroup]="eppRegistrationForm" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="email">Email</label>
              <input
                type="email"
                id="email"
                placeholder="Enter Email"
                tabindex="0"
                formControlName="email"
                class="Inputs form-control"
                readonly />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="firstName">First Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                placeholder="Enter First Name"
                tabindex="0"
                id="firstName"
                formControlName="firstName"
                class="Inputs form-control text-capitalize mt-1"
                maxlength="30"
                minlength="2"
                required
                (input)="onFirstNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'firstName')"
                [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('firstName')?.touched && eppRegistrationForm.get('firstName')?.invalid
                }" />
              <div
                *ngIf="
                  eppRegistrationForm.get('firstName')?.touched && eppRegistrationForm.get('firstName')?.errors as errors
                ">
                <div role="alert" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0001'] }}</div>
                <div role="alert" 
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0002'] }}
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="lastName">Last Name<span class="requiredfield text-danger">*</span></label>
              <input
                type="text"
                id="lastName"
                placeholder="Enter Last Name"
                tabindex="0"
                formControlName="lastName"
                class="Inputs form-control text-capitalize"
                required
                (input)="onLastNameInput($event)"
                (blur)="checkForTrailingSpace($event, 'lastName')"
                [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('lastName')?.touched && eppRegistrationForm.get('lastName')?.invalid
                }" />
              <div
                *ngIf="eppRegistrationForm.get('lastName')?.touched && eppRegistrationForm.get('lastName')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0004'] }}</div>
                <div
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0005'] }}
                </div>
              </div>
            </div>
             <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="department">Department</label>
              <input
                type="text"
                id="department"
                placeholder="Enter Department"
                tabindex="0"
                formControlName="department"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="ondepartmentInput($event)"
                (blur)="onFieldBlur($event, 'department')"
                [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('department')?.touched && eppRegistrationForm.get('department')?.invalid
                }" />
              <div
                *ngIf="eppRegistrationForm.get('department')?.touched && eppRegistrationForm.get('department')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div role="alert" 
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-lg-3">
            
             <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="title">Title</label>
              <input
                type="text"
                id="title"
                name="title"
                autocomplete="organization-title"
                placeholder="Enter Title"
                tabindex="0"
                formControlName="title"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="60"
                (input)="onTitleInput($event)"
                (blur)="onFieldBlur($event, 'title')"
               [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('title')?.touched && eppRegistrationForm.get('title')?.invalid
                }" />
              <div
                *ngIf="eppRegistrationForm.get('title')?.touched && eppRegistrationForm.get('title')?.errors as errors">
                <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
                <div
                  *ngIf="!errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="eppProvider">EPP Provider</label>
              <select
                id="eppProvider"
                tabindex="0"
                formControlName="eppProvider"
                class="Inputs form-control">
                <option value="" disabled>Select EPP Provider</option>
                <option *ngFor="let provider of eppProviderList" [value]="provider.key">
                  {{ provider.value }}
                </option>
              </select>
            </div>
           <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="streetAddress">Street Address</label>
              <input
                type="streetAddress"
                id="streetAddress"
                placeholder="Enter Street Address"
                tabindex="0"
                formControlName="streetAddress"
                class="Inputs form-control"
                readonly />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="city">City</label>
              <input
                type="text"
                id="city"
                placeholder="Enter City"
                tabindex="0"
                formControlName="city"
                class="Inputs form-control text-capitalize"
                readonly
                [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('city')?.touched && eppRegistrationForm.get('city')?.invalid
                }" />
            </div>
          </div>
          <div class="row mt-lg-3">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="state">State</label>
              <input
                type="text"
                id="state"
                placeholder="Enter State"
                tabindex="0"
                formControlName="state"
                class="Inputs form-control text-capitalize"
                readonly
                [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('state')?.touched && eppRegistrationForm.get('state')?.invalid
                }" />
              <div
                *ngIf="eppRegistrationForm.get('state')?.touched && eppRegistrationForm.get('state')?.errors as errors">
                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">state</div>
                <div
                  *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  state
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="zipCode">ZIP Code</label>
              <input
                type="zipCode"
                id="zipCode"
                placeholder="Enter Zip Code"
                tabindex="0"
                formControlName="zipCode"
                class="Inputs form-control"
                readonly />
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="input_registration_form_phone_number">Phone Number</label>
              <input
                type="text"
                id="input_registration_form_phone_number"
                formControlName="phoneNumber"
                class="form-control"
                aria-required="true"
                [attr.aria-invalid]="(eppRegistrationForm.get('phoneNumber')?.touched && eppRegistrationForm.get('phoneNumber')?.invalid) || phoneExists ? 'true' : null"
                [attr.aria-describedby]="(eppRegistrationForm.get('phoneNumber')?.touched && eppRegistrationForm.get('phoneNumber')?.invalid) || phoneExists ? 'phoneNumber-error' : null"
                placeholder="Enter Phone Number"
                tabindex="0"
                (input)="formatPhoneNumber($event)"
                (focus)="isPhoneFocused = true"
                (blur)="isPhoneFocused = false; checkPhone()"
                numbersOnly
                [ngClass]="{
                  'is-invalid':
                    (eppRegistrationForm.get('phoneNumber')?.touched && eppRegistrationForm.get('phoneNumber')?.invalid) || phoneExists
                }" />
              <!-- Form validation errors -->
              <div *ngIf="eppRegistrationForm.get('phoneNumber')?.touched && eppRegistrationForm.get('phoneNumber')?.errors as errors">
                <div id="phoneNumber-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0016'] }}</div>
                <div id="phoneNumber-error" *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                  {{ errorMessage['M0017'] }}
                </div>
              </div>
              <!-- Server-side validation error -->
              <div id="phoneNumber-error" *ngIf="phoneExists" class="text-danger mt-1 err-font">
                The phone number entered is already on file.
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 col-sm-12">
              <label for="extension">Extension</label>
              <input
                type="text"
                id="extension"
                placeholder="Enter Extension"
                tabindex="0"
                formControlName="extension"
                class="Inputs form-control text-capitalize"
                minlength="2"
                maxlength="10"
                (input)="onExtensionInput($event)"
               [ngClass]="{
                  'is-invalid': eppRegistrationForm.get('extension')?.touched && eppRegistrationForm.get('extension')?.invalid
                }" />
              <div
                *ngIf="eppRegistrationForm.get('extension')?.touched && eppRegistrationForm.get('extension')?.errors as errors">
                <div
                  *ngIf="(errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                  class="text-danger mt-1 err-font">
                  {{ errorMessage['M0064'] }}
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="row mt-lg-3">
          </div> -->
          <div class="form-group">
              <div class="form-check mb-0 pb-0">
                <input type="checkbox" id="input_lea_registration_form_terms" formControlName="terms" class="mb-2 mr-3 check-box" required 
                  aria-required="true"
                  [attr.aria-describedby]="eppRegistrationForm.get('terms')?.touched && eppRegistrationForm.get('terms')?.invalid ? 'terms-error' : null" />
                <label
                  for="input_lea_registration_form_terms"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                 I have read and agree to the
                  <a href="javascript:void(0)" tabindex="0" class="link-pointer" (click)="openTermsAndConditionsModal($event)"><u>User Agreement.</u></a>
                  <span class="requiredfield text-danger">*</span>
                </label>
                
              </div>
              <div *ngIf="eppRegistrationForm.get('terms')?.touched && eppRegistrationForm.get('terms')?.errors as errors" class="form-check mt-0">
                  <div id="terms-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
                </div>
              <div class="form-check mt-2 mr-3 mb-0 pb-0">
                <input type="checkbox" id="input_lea_registration_form_consent" formControlName="consent" class="check-box mb-4 mr-3" required 
                  aria-required="true"
                  [attr.aria-describedby]="eppRegistrationForm.get('consent')?.touched && eppRegistrationForm.get('consent')?.invalid ? 'consent-error' : null" />
                <label
                  for="input_lea_registration_form_consent"
                  class="form-check-label mb-0"
                  (click)="$event.preventDefault()"
                  (keypress)="$event.preventDefault()">
                  I consent to receive emails and SMS messages from the Nevada Department of Education Online Portal for Application and Licensure for account verification and official communications.
                  <span class="requiredfield text-danger">*</span>
                </label>
                
              </div>
              <div *ngIf="eppRegistrationForm.get('consent')?.touched && eppRegistrationForm.get('consent')?.errors as errors" class="form-check mt-0">
                <div id="consent-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0044'] }}</div>
              </div>
            </div>
          <hr />
          <div class="row justify-content-end pb-3 mt-2 mr-0 mb-5">
            <div class="d-flex">
              <button type="submit" class="btn btn-primary" [disabled]="eppRegistrationForm.invalid">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- Toast message for errors -->
    <div *ngIf="phoneError" class="toast-message">
      <div class="d-flex">
        <p class="text-white mb-0" role="alert">
          {{currentToastMessage}}
        </p>
        <span class="material-symbols-outlined f-24 mt-4" 
              style="cursor: pointer;" 
              (click)="closeErrorToast()" 
              title="Close">close</span>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-content">
      <div class="d-flex text-black modal-header pl-4 pr-4 mt-3">
        <h5 class="font-18">Terms &amp; conditions</h5>
        <button type="button" class="btn p-0" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span class="material-symbols-outlined"> close </span>
        </button>
      </div>

      <div class="modal-body termscondition"></div>
    </div>
  </ng-template>
</div>

<div class="modal-overlay" *ngIf="showModal" (click)="closeModal()" (keydown.escape)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeModal()">
      <i class="fas fa-times"></i>
    </button>
    <div class="modal-body">
      <div class="success-icon">
        <img src="../../../assets/images/cardy-ai/tick logo.png" alt="Success" width="60" height="60" />
      </div>
      <p class="modal-subtitle">{{ toastMessage['T0027'] || 'Registration completed. A confirmation email will be sent to you shortly with further instructions.' }}</p>
    </div>
  </div>
</div>
